import React, {useContext, useEffect, useState} from 'react';

import { Card, Row, Col, Form, Table } from "react-bootstrap";
import { FaCalendarMinus, FaCalendar, FaCalendarPlus, FaUmbrellaBeach } from 'react-icons/fa';
import Ticket from '../../components/Ticket'
import Loading from '../../components/Loading';

import VacationContext from '../../context/Vacation/VacationContext';

const Vacations = () => {

    const vacationContext = useContext(VacationContext);
    const { vacation, loading, getVacationByUser } = vacationContext;


    const [data, setData] = useState({   
            dayByMonth: null,
            vacationTaken: null,
            totalVacation: null,
            hiringDate: null,
            vacations: []            
        });

        useEffect(() => {
            const callVacationByUser = async () => {
                getVacationByUser()
            }
            if(!vacation) {callVacationByUser();}
            else {setData(vacation);}
            // eslint-disable-next-line
        }, [vacation])

    return ( 
        <>
            <Row>
                <Col>
                    <h1 className="h3 mb-2 text-gray-800">Vacaciones</h1>
                    <hr />
                </Col>
            </Row>

            <Row>
                <Ticket col={3} loading={loading} variant={"info"} title={"Fecha de ingreso"} body={data.hiringDate} icon={<FaCalendar size={"2rem"} />}/>                 
                <Ticket col={3} loading={loading} variant={"success"} title={"Feriados Legales Acumulados"} body={data.totalVacation} icon={<FaUmbrellaBeach size={"2rem"} />} />
                <Ticket col={3} loading={loading} variant={"warning"} title={"Día por mes Trabajado"} body={data.dayByMonth} icon={<FaCalendarPlus size={"2rem"} />}/>                
                <Ticket col={3} loading={loading} variant={"danger"} title={"Feriados legales Descontados"} body={data.vacationTaken} icon={<FaCalendarMinus size={"2rem"} />}/>
            </Row>

            <Row >     
                <Col lg={6}>
                    <Card className="shadow mb-4">
                        <Card.Header className="card-header py-3 m-0 font-weight-bold text-primary">Detalle</Card.Header>
                        <Card.Body>
                            
                            <Card.Text >
                                {loading ? <Loading /> :
                                <Table responsive striped bordered hover size="sm" >
                                    <thead>
                                        <tr className="text-center">
                                        <th className="text-center">#</th>
                                        <th>Fecha inicio</th>
                                        <th>Fecha termino</th>
                                        <th className="text-center">Días descontados</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.vacations.map((vacation, i) => (
                                            <tr className="text-center" key={vacation.id}>
                                                <td className="text-center">{i+1}</td>
                                                <td>{vacation.startDate}</td>
                                                <td>{vacation.endDate}</td>
                                                <td className="text-center">{vacation.totalDays}</td>
                                         </tr>
                                        ))}                                       
                                    </tbody>
                                </Table>
                                }
                            </Card.Text>
                            
                        </Card.Body>
                    </Card>
                </Col>       

                <Col lg={6}>
                    <Card className="shadow mb-4">
                        <Card.Header className="card-header py-3 m-0 font-weight-bold text-primary">Simulador</Card.Header>
                        <Card.Body>
                            
                            <Card.Text >
                                <Form>
                                    <Form.Group as={Row} controlId="formHorizontalEmail">
                                        <Form.Label column sm={6}>
                                            Fecha que desea tomar vacaciones
                                        </Form.Label>
                                        <Col sm={6}>
                                            <Form.Control type="date" placeholder="Nombre" size="" />
                                        </Col>                                       
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="formHorizontalEmail">
                                        <Form.Label column sm={6}>
                                            Fecha termino de vacaciones
                                        </Form.Label>
                                        <Col sm={6}>
                                            <Form.Control type="date" placeholder="Nombre" size="" />
                                        </Col>                                       
                                    </Form.Group>

                                    <hr />
                                    <Form.Group as={Row} controlId="formHorizontalEmail">
                                        <Form.Label column sm={6}>
                                        Días disponibles a la fecha:
                                        </Form.Label>
                                        <Col sm={6}>
                                            <Form.Control type="text" placeholder="Nombre" size="" disabled value="15 Días" className="text-primary"/>
                                        </Col>                                       
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="formHorizontalEmail">
                                        <Form.Label column sm={6}>
                                            Días tomados
                                        </Form.Label>
                                        <Col sm={6}>
                                            <Form.Control type="text" placeholder="Nombre" size="" disabled value="15 Días" className="text-danger"/>
                                        </Col>                                       
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="formHorizontalEmail">
                                        <Form.Label column sm={6}>
                                            Días totales por tomar
                                        </Form.Label>
                                        <Col sm={6}>
                                            <Form.Control type="text" placeholder="Nombre" size="" disabled value="15 Días" className="text-success"/>
                                        </Col>                                       
                                    </Form.Group>
                                   
                                </Form>
                            </Card.Text>
                            
                        </Card.Body>
                    </Card>
                </Col>              
            </Row>
        </>
     );
}
 
export default Vacations;
